import { isEmpty } from "lodash";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  enabled_schedule_a_tour: true,
  schedule_a_tour: true,
  find_a_home: true,
  in_person_tour: true,
  live_video_tour: true,
  self_guided_tour: true,
  self_tour_link_in_hytours: true,
  self_tour_show_in_popup: true,
  self_tour_link: null,
  visit_resident_portal: true,
  photos: true,
  videos: true,
  community_info: true,
  isJAI: false,
  showFaq: false,
  showFeedback: false,
  customFormQuestion: null,
  site_id: "",
  jai_edit_url: "",
  property_id: "",
  property_name: "",
  api_key: "",
  header_bg_color: "#26BBED",
  header_txt_color: "#FFF",
  button_bg_color: "#26BBED",
  reset_btn_color: "#26BBED",
  button_border_color: "#999",
  button_txt_color: "#333",
  font_family: "'Open Sans', sans-serif",
  message_color: "#333",
  link_color: "#4F6FAE",
  artieLogo: "",
  logoType: "",
  isSpanishLanguage: false,
  isMultiLanguage: false,
  isPriceFilter: false,
  showContactSMSOpt: true,
  showTourSMSOpt: true,
  chatbotTitleDetails: {
    widget_title: "Hayley",
    chatbot_title: "",
  },
  customButtons: null,
  qualificationButtonEnabled: true,
  qualificationButton: true,
  showContactTransactionalMsg: false,
  hyFormsTransactionalMsg: "",
  showContactPromotionalMsg: false,
  hyFormsPromotionMsg: "",
  showTourTransactionMsg: false,
  hyToursTransactionalMsg: "",
  showTourPromotionalMsg: false,
  hyTourPromotionMsg: "",
  entry_id: "",
  email: "",
  isFormDisclaimerEnabled: false,
  disclaimerData: null,
};

export const propertySlice = createSlice({
  name: "property",
  initialState,
  reducers: {
    setEnabledScheduleATour: (state, action) => {
      state.enabled_schedule_a_tour = action.payload;
    },
    setVisibleScheduleATour: (state, action) => {
      state.schedule_a_tour = action.payload;
    },
    setVisibleFindAHome: (state, action) => {
      state.find_a_home = action.payload;
    },
    setVisibleInPersonTour: (state, action) => {
      state.in_person_tour = action.payload;
    },
    setVisibleLiveVideoTour: (state, action) => {
      state.live_video_tour = action.payload;
    },
    setVisibleSelfGuidedTour: (state, action) => {
      state.self_guided_tour = action.payload;
    },
    setTourLinkInHyTours: (state, action) => {
      state.self_tour_link_in_hytours = action.payload;
    },
    setTourShowInPopup: (state, action) => {
      state.self_tour_show_in_popup = action.payload;
    },
    setSelfTourLink: (state, action) => {
      state.self_tour_link = action.payload;
    },
    setVisibleVisitResidentPortal: (state, action) => {
      state.visit_resident_portal = action.payload;
    },
    setVisiblePhotos: (state, action) => {
      state.photos = action.payload;
    },
    setVisibleVideos: (state, action) => {
      state.videos = action.payload;
    },
    setVisibleCommunityInfo: (state, action) => {
      state.community_info = action.payload;
    },
    setIsJAI: (state, action) => {
      state.isJAI = action.payload;
    },
    setSiteId: (state, action) => {
      state.site_id = action.payload;
    },
    setOrgId: (state, action) => {
      state.org_id = action.payload;
    },
    setJaiEditUrl: (state, action) => {
      state.jai_edit_url = action.payload;
    },
    setPropertyId: (state, action) => {
      state.property_id = action.payload;
    },
    setPropertyName: (state, action) => {
      state.property_name = action.payload;
    },
    setAPIKey: (state, action) => {
      state.api_key = action.payload;
    },
    setButtonBgColor: (state, action) => {
      state.button_bg_color = isEmpty(action.payload) ? "#26BBED" : action.payload;
      state.header_bg_color = isEmpty(action.payload) ? "#26BBED" : action.payload;
      state.reset_btn_color = isEmpty(action.payload) ? "#26BBED" : action.payload;
    },
    setButtonBorderColor: (state, action) => {
      state.button_border_color = isEmpty(action.payload) ? "#999" : action.payload;
    },
    setButtonTxtColor: (state, action) => {
      state.button_txt_color = isEmpty(action.payload) ? "#333" : action.payload;
      state.header_txt_color = isEmpty(action.payload) ? "#FFF" : action.payload;
    },
    setFontFamily: (state, action) => {
      state.font_family = isEmpty(action.payload) ? "'Open Sans', sans-serif" : `${action.payload}, 'Open Sans', sans-serif`;
    },
    setMessageColor: (state, action) => {
      state.message_color = isEmpty(action.payload) ? "#333" : action.payload;
    },
    setLinkColor: (state, action) => {
      state.link_color = isEmpty(action.payload) ? "#4F6FAE" : action.payload;
    },
    setArtieLogo: (state, action) => {
      state.artieLogo = action.payload;
    },
    setLogoType: (state, action) => {
      state.logoType = action.payload;
    },
    setChatbotTitleDetails: (state, action) => {
      state.chatbotTitleDetails = action.payload;
    },
    setIsSpanishLanguage: (state, action) => {
      state.isSpanishLanguage = action.payload;
    },
    setIsPhoneNumberRequired: (state, action) => {
      state.isPhoneNumberRequired = action.payload;
    },
    setIsMultiLanguage: (state, action) => {
      state.isMultiLanguage = action.payload;
    },
    setIsPriceFilter: (state, action) => {
      state.isPriceFilter = action.payload;
    },
    setShowTourSMSOpt: (state, action) => {
      state.showTourSMSOpt = action.payload;
    },
    setShowContactSMSOpt: (state, action) => {
      state.showContactSMSOpt = action.payload;
    },
    setShowFaq: (state, action) => {
      state.showFaq = action.payload;
    },
    setShowFeedback: (state, action) => {
      state.showFeedback = action.payload;
    },
    setCustomFormQuestion: (state, action) => {
      state.customFormQuestion = action.payload;
    },
    setCustomButtons: (state, action) => {
      state.customButtons = action.payload;
    },
    setQualificationButton: (state, action) => {
      state.qualificationButton = action.payload;
    },
    setQualificationButtonEnabled: (state, action) => {
      state.qualificationButtonEnabled = action.payload;
    },

    setShowContactTransactionalMsg: (state, action) => {
      state.showContactTransactionalMsg = action.payload;
    },
    setContactTransactionalMsg: (state, action) => {
      state.hyFormsTransactionalMsg = action.payload;
    },
    setShowContactPromotionMsg: (state, action) => {
      state.showContactPromotionalMsg = action.payload;
    },
    setContactPromotionMsg: (state, action) => {
      state.hyFormsPromotionMsg = action.payload;
    },
    setShowTourTransactionalMsg: (state, action) => {
      state.showTourTransactionMsg = action.payload;
    },
    setTourTransactionalMsg: (state, action) => {
      state.hyToursTransactionalMsg = action.payload;
    },
    setShowTourPromotionMsg: (state, action) => {
      state.showTourPromotionalMsg = action.payload;
    },
    setTourPromotionMsg: (state, action) => {
      state.hyTourPromotionMsg = action.payload;
    },
    setEntryId: (state, action) => {
      state.entry_id = action.payload;
      localStorage.setItem(`${state.property_id}-entry_id`, action?.payload || "");
    },
    setEmail: (state, action) => {
      state.email = action.payload;
      localStorage.setItem(`${state.property_id}-email`, action?.payload || "");
    },
    setFormDisclaimer: (state, action) => {
      const disclaimer = action.payload;
      const enabled = !!disclaimer?.orgLevelDisclaimerEnabled;

      state.isFormDisclaimerEnabled = enabled;
      state.disclaimerData = disclaimer;
    },
  },
});

export const {
  setEnabledScheduleATour,
  setVisibleScheduleATour,
  setVisibleFindAHome,
  setVisibleInPersonTour,
  setVisibleLiveVideoTour,
  setVisibleSelfGuidedTour,
  setTourLinkInHyTours,
  setTourShowInPopup,
  setSelfTourLink,
  setVisibleVisitResidentPortal,
  setVisiblePhotos,
  setVisibleVideos,
  setVisibleCommunityInfo,
  setIsJAI,
  setSiteId,
  setOrgId,
  setAPIKey,
  setPropertyId,
  setPropertyName,
  setButtonBgColor,
  setButtonBorderColor,
  setButtonTxtColor,
  setFontFamily,
  setMessageColor,
  setLinkColor,
  setArtieLogo,
  setLogoType,
  setJaiEditUrl,
  setChatbotTitleDetails,
  setIsSpanishLanguage,
  setIsPhoneNumberRequired,
  setIsMultiLanguage,
  setIsPriceFilter,
  setShowTourSMSOpt,
  setShowContactSMSOpt,
  setShowFaq,
  setShowFeedback,
  setCustomFormQuestion,
  setCustomButtons,
  setQualificationButton,
  setQualificationButtonEnabled,
  setShowContactTransactionalMsg,
  setContactTransactionalMsg,
  setShowContactPromotionMsg,
  setContactPromotionMsg,
  setShowTourTransactionalMsg,
  setTourTransactionalMsg,
  setShowTourPromotionMsg,
  setTourPromotionMsg,
  setEntryId,
  setEmail,
  setFormDisclaimer,
} = propertySlice.actions;

export const getEnabledScheduleTour = (state) => state.property.enabled_schedule_a_tour;
export const getVisibleScheduleTour = (state) => state.property.schedule_a_tour;
export const getVisibleFindHome = (state) => state.property.find_a_home;
export const getVisibleInPersonTour = (state) => state.property.in_person_tour;
export const getVisibleLiveVideoTour = (state) => state.property.live_video_tour;
export const getVisibleSelfGuidedTour = (state) => state.property.self_guided_tour;
export const getTourLinkInHyTours = (state) => state.property.self_tour_link_in_hytours;
export const getTourShowInPopup = (state) => state.property.self_tour_show_in_popup;
export const getSelfTourLink = (state) => state.property.self_tour_link;
export const getVisibleVisitResidentPortal = (state) => state.property.visit_resident_portal;
export const getVisiblePhotos = (state) => state.property.photos;
export const getVisibleVideos = (state) => state.property.videos;
export const getVisibleCommunityInfo = (state) => state.property.community_info;
export const selectIsJAI = (state) => state.property.isJAI;
export const selectSiteId = (state) => state.property.site_id;
export const getOrgId = (state) => state.property.org_id;
export const getJaiEditUrl = (state) => state.property.jai_edit_url;
export const selectAPIKey = (state) => state.property.api_key;
export const selectPropertyId = (state) => state.property.property_id;
export const selectPropertyName = (state) => state.property.property_name;
export const getButtonBgColor = (state) => state.property.button_bg_color;
export const getButtonBorderColor = (state) => state.property.button_border_color;
export const getButtonTxtColor = (state) => state.property.button_txt_color;
export const getFontFamily = (state) => state.property.font_family;
export const getMessageColor = (state) => state.property.message_color;
export const getLinkColor = (state) => state.property.link_color;
export const getHeaderBgColor = (state) => state.property.header_bg_color;
export const getResetBtnColor = (state) => state.property.reset_btn_color;
export const getHeaderTxtColor = (state) => state.property.header_txt_color;
export const getArtieLogo = (state) => state.property.artieLogo;
export const getLogoType = (state) => state.property.logoType;
export const getChatbotTitleDetails = (state) => state.property.chatbotTitleDetails;
export const getSpanishLanguage = (state) => state.property.isSpanishLanguage;
export const getMultiLanguage = (state) => state.property.isMultiLanguage;
export const getPriceFilter = (state) => state.property.isPriceFilter;
export const getPhoneNumberFilter = (state) => state.property.isPhoneNumberRequired;
export const getShowTourSMSOpt = (state) => state.property.showTourSMSOpt;
export const getShowContactSMSOpt = (state) => state.property.showContactSMSOpt;
export const getShowFaq = (state) => state.property.showFaq;
export const getShowFeedback = (state) => state.property.showFeedback;
export const getCustomFormQuestion = (state) => state.property.customFormQuestion;
export const getCustomButtons = (state) => state.property.customButtons;
export const getQualificationButtonEnabled = (state) => state.property.qualificationButtonEnabled;
export const getQualificationButton = (state) => state.property.qualificationButton;
export const getContactTransactionalMsg = (state) => state.property.showContactTransactionalMsg;
export const getHyformsTransactionalMsg = (state) => state.property.hyFormsTransactionalMsg;
export const getContactPromotionMsg = (state) => state.property.showContactPromotionalMsg;
export const getHyformsPromotionMsg = (state) => state.property.hyFormsPromotionMsg;

export const getTourTransactionalMsg = (state) => state.property.showTourTransactionMsg;
export const getHyTourTransactionalMsg = (state) => state.property.hyToursTransactionalMsg;
export const getTourPromotionMsg = (state) => state.property.showTourPromotionalMsg;
export const getHyToursPromotionMsg = (state) => state.property.hyTourPromotionMsg;
export const getEntryId = (state) => state?.property?.entry_id || localStorage.getItem(`${state?.property?.property_id}-entry_id`) || "";
export const getEmail = (state) => state?.property?.email || localStorage.getItem(`${state?.property?.property_id}-email`) || "";
export const getFormDisclaimer = (state) => state?.property?.isFormDisclaimerEnabled;
export const getFormDisclaimerData = (state) => state?.property?.disclaimerData;

export default propertySlice.reducer;
